/**
 * Mando UI initialisation
 */

/* eslint-disable */
import Vue from "NodeModules/vue/dist/vue.min.js";

// Simple observable event bus to allow communication between components
Vue.prototype.$eventBus = new Vue();

import moment from "NodeModules/moment/moment";
import polyfillClosest from "../polyfill";
import header from "Components/wessexwatercorporate/header/header";
import navigationOffCanvas from "Components/wessexwatercorporate/navigation/navigation-off-canvas";
import navigationDropdown from "Components/wessexwatercorporate/navigation-dropdown/navigation-dropdown";
import search from "Components/wessexwatercorporate/search/search";
import accordion from "Components/wessexwatercorporate/accordion/mando-ui.accordion";
import videoHero from "Components/wessexwatercorporate/hero/mando-ui.video-hero";
import tabs from "Components/wessexwatercorporate/tabs/mando-ui.tabs";
import cardCarousel from "Components/wessexwatercorporate/card-carousel/card-carousel";
import notify from "Components/wessexwatercorporate/notify/notify";
import videoPlayer from "Components/wessexwatercorporate/video/video";
import person from "Components/wessexwatercorporate/person/person";
import waterMeterTool from 'Components/wessexwatercorporate/water-meter-tool/water-meter-tool';

import searchResults from "Components/wessexwatercorporate/results/SearchResults.vue";
import childPageCtas from "Components/wessexwatercorporate/child-page-ctas/ChildPageCtas.vue";

document.addEventListener("DOMContentLoaded", () => {
  // Add JS helper class
  document.getElementsByTagName("html")[0].classList.remove("no-js");
  document.getElementsByTagName("html")[0].classList.add("has-js");

  //* Polyfill
  polyfillClosest();
  // Components
  header();
  navigationOffCanvas();
  navigationDropdown();
  search();
  accordion();
  videoHero();
  tabs();
  cardCarousel();
  notify();
  videoPlayer();
  person();
  waterMeterTool();

  const searchResultsEl = document.querySelector("#search-results");
  const childPageCtasEls = document.querySelectorAll(".child-page-ctas");

  Vue.filter("formatDate", (value) => {
    if (!value) {
      return "";
    }
    return moment(value).format("DD/MM/YY");
  });

  Vue.filter("formatFileSize", (value) => {
    return `${(value / Math.pow(1024, 1)).toFixed(2)}kB`;
  });

  Vue.filter("booleanToYesNo", (value) => (value ? "Yes" : "No"));

  if (searchResultsEl) {
    /* eslint-disable no-new */
    new Vue({
      el: "#search-results",
      render: (h) =>
        h(searchResults, {
          props: {
            searchLabel: searchResultsEl.dataset.searchLabel,
            searchDescription: searchResultsEl.dataset.searchDescription,
            sites: JSON.parse(searchResultsEl.dataset.sites)
          },
        }),
    });
    /* eslint-enable */
  }

  if (childPageCtasEls.length) {
    /* eslint-disable no-new */
    childPageCtasEls.forEach(
      (childPageCtasEl) =>
        new Vue({
          el: ".child-page-ctas",
          render: (h) =>
            h(childPageCtas, {
              props: {
                componentId: childPageCtasEl.dataset.componentId,
                pageId: childPageCtasEl.dataset.pageId,
                options: JSON.parse(childPageCtasEl.dataset.options),
                theme: childPageCtasEl.dataset.theme,
              },
            }),
        })
    );

    /* eslint-enable */
  }
});



// WEBPACK FOOTER //
// ./src/scripts/brands/wessexwatercorporate.js